import React from "react";
import {Button, Drawer, Form, Input, message, Select} from "antd";
import {WasteStreamCodeGet, WasteStreamCodePost, WasteStreamCodeUpdate} from "../../../../../models/waste_stream_code";
import {UnitDropdown} from "../../../../../controller/Global";
import {ContainerTypeFilter} from "../../../../../filters/ContainerType";

const FormItem = Form.Item;
const { Option } = Select;

class EditWasteStreamDataForm extends React.Component {
    state = {};
    fetchTruckType = (id) => {
        let form = this.props.form;
        WasteStreamCodeGet(id)
            .then(response => {
                    form.setFieldsValue(
                        {
                            code: response.data.code,
                            unit: response.data.unit,
                            description: response.data.description,
                            category: response.data.category,
                        },
                    );
                    this.container.handleChange({
                        key: response.data.container.id,
                        label: response.data.container.name
                    });
                }
            );
    }
    handleDrawerSubmit = (e) => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (!this.props.row_id) {
                    WasteStreamCodePost(values)
                        .then(response => {
                            message.success('Waste Stream Create Successfully');
                            this.handlePopupAfterAddUpdate();
                        })
                }
                else {
                    WasteStreamCodeUpdate(this.props.row_id, values)
                        .then(response => {
                            message.success('Waste Stream Updated Successfully');
                            this.handlePopupAfterAddUpdate();
                        });
                }
            }
        });
    };
    handlePopupAfterAddUpdate = () => {
        this.props.onClose()
        this.props.fetch();
    };

    componentDidMount() {
        if (this.props.onRef)
            this.props.onRef(this)
    }

    componentDidUpdate(prevProps) {
        const {visible, row_id} = this.props;
        if (visible && row_id && (visible !== prevProps.visible && row_id !== prevProps.row_id))
            this.fetchTruckType(row_id);
    }

    componentWillUnmount() {
        if (this.props.onRef)
            this.props.onRef(null)
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const {fields} = this.state;

        return (
            <Drawer title={this.props.row_id ? "Update Waste Stream" : "Create Waste Stream"} placement="right"
                    row_id={this.props.row_id} onClose={this.props.onClose} visible={this.props.visible}
                    className="floating-form" destroyOnClose={true}>
                <Form>
                    <FormItem>
                        {getFieldDecorator('code', {
                            rules: [{
                                required: true, message: 'Please input waste stream code',
                            }],
                        })(
                            <Input placeholder="Enter Waste Stream Code"/>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('unit', {
                            rules: [{required: true, message: 'Please select unit'}],
                        })(<Select className="unit-ws" placeholder="Select Unit" {...fields}>
                            {UnitDropdown()}
                        </Select>)}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('description', {
                            rules: [{
                                required: true, message: 'Please input waste stream description',
                            }],
                        })(
                            <Input placeholder="Enter Waste Stream Description"/>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('category', {
                            rules: [{
                                required: true, message: 'Please input waste stream category',
                            }],
                        })(<Select placeholder="Choose Category">
                            <Option value="Oil">Oil</Option>
                                <Option value="Water">Water</Option>
                                <Option value="AF">AF</Option>
                                <Option value="SL">SL</Option>
                            </Select>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('container', {
                            rules: [{
                                required: true, message: 'Please choose container',
                            }],
                        })(
                            <ContainerTypeFilter onRef={ref => (this.container = ref)}/>
                        )}
                    </FormItem>
                    <Button type="primary" htmlType="button"
                            onClick={this.handleDrawerSubmit}>{this.props.row_id ? "Update Waste Stream" : "Create Waste Stream"}</Button>
                </Form>
            </Drawer>
        )
    }
}

export const EditWasteStreamData = Form.create()(EditWasteStreamDataForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/data_management/waste_stream_data/popups/EditWasteStreamData.jsx